<div class="p-4 md:p-6 max-w-full mx-auto">

  <!-- Header -->
  <div class="flex items-center gap-3 mb-4">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">description</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">
      Carga Saldo VES
      <span *ngIf="total > 0" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
        {{ total }} registros
      </span>
    </h1>
  </div>

  <!-- Badge mobile -->
  <span *ngIf="total > 0" class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-3">
    {{ total }} registros
  </span>

  <!-- Tabs cliente / operador -->
  <div class="flex items-center justify-between gap-2 mb-4 flex-wrap" style="border-bottom: 1px solid #e5e7eb;">
    <div class="flex items-center gap-2">
      <button type="button" (click)="setTab('cliente')"
        style="padding: 10px 18px; background: transparent; border: none; border-bottom: 3px solid transparent; font-weight: 700; font-size: 0.88rem; cursor: pointer; transition: all 0.15s ease;"
        [style.color]="activeTab === 'cliente' ? '#1C593D' : '#6b7280'"
        [style.borderBottomColor]="activeTab === 'cliente' ? '#1C593D' : 'transparent'">
        Cargas de cliente
      </button>
      <button type="button" (click)="setTab('operador')"
        style="padding: 10px 18px; background: transparent; border: none; border-bottom: 3px solid transparent; font-weight: 700; font-size: 0.88rem; cursor: pointer; transition: all 0.15s ease;"
        [style.color]="activeTab === 'operador' ? '#1C593D' : '#6b7280'"
        [style.borderBottomColor]="activeTab === 'operador' ? '#1C593D' : 'transparent'">
        Carga saldo cuenta interna
      </button>
    </div>

    <button *ngIf="activeTab === 'operador'" type="button" (click)="openRegistrarOperadorModal()"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 18px; margin-bottom: 6px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">post_add</mat-icon>
      Registrar referencia
    </button>
  </div>

  <!-- Sub-tabs por banco / rail -->
  <div class="flex items-center gap-2 mb-4 flex-wrap">
    <span style="font-size: 0.78rem; font-weight: 600; color: #6b7280; margin-right: 4px;">Banco:</span>
    <button type="button" (click)="setRail('ALL')"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 999px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.15s ease; border: 1px solid;"
      [style.background]="activeRail === 'ALL' ? '#1C593D' : 'white'"
      [style.color]="activeRail === 'ALL' ? 'white' : '#374151'"
      [style.borderColor]="activeRail === 'ALL' ? '#1C593D' : '#d1d5db'">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">apps</mat-icon>
      Todos
    </button>
    <button type="button" (click)="setRail('N58')"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 999px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.15s ease; border: 1px solid;"
      [style.background]="activeRail === 'N58' ? '#1C593D' : 'white'"
      [style.color]="activeRail === 'N58' ? 'white' : '#374151'"
      [style.borderColor]="activeRail === 'N58' ? '#1C593D' : '#d1d5db'">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">account_balance</mat-icon>
      N58
    </button>
    <button type="button" (click)="setRail('BANCO_PLAZA')"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 999px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.15s ease; border: 1px solid;"
      [style.background]="activeRail === 'BANCO_PLAZA' ? '#1C593D' : 'white'"
      [style.color]="activeRail === 'BANCO_PLAZA' ? 'white' : '#374151'"
      [style.borderColor]="activeRail === 'BANCO_PLAZA' ? '#1C593D' : '#d1d5db'">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">account_balance</mat-icon>
      Banco Plaza
    </button>
    <button type="button" (click)="setRail('R4')"
      style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 14px; border-radius: 999px; font-weight: 600; font-size: 0.78rem; cursor: pointer; transition: all 0.15s ease; border: 1px solid;"
      [style.background]="activeRail === 'R4' ? '#1C593D' : 'white'"
      [style.color]="activeRail === 'R4' ? 'white' : '#374151'"
      [style.borderColor]="activeRail === 'R4' ? '#1C593D' : '#d1d5db'">
      <mat-icon style="font-size: 14px; width: 14px; height: 14px;">account_balance</mat-icon>
      R4 Conecta
    </button>
  </div>

  <!-- Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros de b&uacute;squeda
      </h2>
    </div>
    <div class="p-5">
      <form [formGroup]="filterForm" (ngSubmit)="applyFilters()">
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Usuario ID</mat-label>
            <input matInput formControlName="userId" placeholder="Ej: 918" />
            <mat-icon matPrefix>person</mat-icon>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full modern-field">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="status">
              <mat-option value="">Todos</mat-option>
              <mat-option value="PENDING">Pendiente</mat-option>
              <mat-option value="APPROVED">Aprobada</mat-option>
              <mat-option value="REJECTED">Rechazada</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="flex flex-col sm:flex-row justify-center gap-3 mt-4">
          <button type="submit" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
            Buscar
          </button>
          <button type="button" (click)="clearFilters()" [disabled]="loading"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            [style.opacity]="loading ? '0.5' : '1'"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
        </div>
      </form>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="40"></mat-spinner>
    <span class="ml-3 text-gray-600">Cargando referencias...</span>
  </div>

  <ng-container *ngIf="!loading">

    <!-- Tabla Desktop -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden hidden lg:block" *ngIf="referencias.length > 0">
      <div style="overflow-x: auto;">
        <table mat-table [dataSource]="referencias" style="width: 100%;">

          <ng-container matColumnDef="userId">
            <th mat-header-cell *matHeaderCellDef>Usuario</th>
            <td mat-cell *matCellDef="let row">
              <!-- Una fila de operador no tiene usuario: su `user_id` es un
                   centinela, o basura heredada del bug de atribución. -->
              <span *ngIf="!row.esOperador" class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">{{ row.userId }}</span>
              <span *ngIf="row.esOperador" class="font-bold text-xs px-2 py-0.5 rounded-full" style="background: #eef2ff; color: #4338ca;">Operador</span>
            </td>
          </ng-container>

          <ng-container matColumnDef="userName">
            <th mat-header-cell *matHeaderCellDef>Cliente / Operador</th>
            <td mat-cell *matCellDef="let row">
              <ng-container *ngIf="!row.esOperador">
                <div style="font-size: 0.82rem; font-weight: 600; color: #374151; max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ row.usuario?.nombre }} {{ row.usuario?.apellidos }}
                </div>
                <div style="font-size: 0.7rem; color: #6b7280;">{{ row.usuario?.email }}</div>
              </ng-container>
              <!-- El operador existe sólo en Cognito: su mail es toda su
                   identidad, y es lo que quedó guardado al registrar. -->
              <div *ngIf="row.esOperador" style="font-size: 0.78rem; color: #4338ca; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{ row.operatorEmail || 'sin operador registrado' }}
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="cuentaDestino">
            <th mat-header-cell *matHeaderCellDef>Cuenta destino</th>
            <td mat-cell *matCellDef="let row">
              <div style="font-size: 0.82rem; font-weight: 600; color: #374151;">{{ row.titular }}</div>
              <div style="font-size: 0.75rem; color: #6b7280;">{{ row.banco }}</div>
              <div style="font-family: monospace; font-size: 0.75rem; color: #374151;">{{ row.cuenta }}</div>
              <div *ngIf="row.status === 'PENDING' && row.cuentaTrabajoMatch" style="display: flex; align-items: center; gap: 3px; margin-top: 2px;">
                <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #16a34a;">link</mat-icon>
                <span style="font-size: 0.65rem; color: #16a34a; font-weight: 600;">CT #{{ row.cuentaTrabajoMatch.cuenta_trabajo_id }}</span>
              </div>
              <div *ngIf="row.status === 'PENDING' && !row.cuentaTrabajoMatch" style="display: flex; align-items: center; gap: 3px; margin-top: 2px;">
                <mat-icon style="font-size: 12px; width: 12px; height: 12px; color: #dc2626;">link_off</mat-icon>
                <span style="font-size: 0.65rem; color: #dc2626; font-weight: 600;">Sin CT</span>
              </div>
            </td>
          </ng-container>

          <ng-container matColumnDef="referencia">
            <th mat-header-cell *matHeaderCellDef>Referencia</th>
            <td mat-cell *matCellDef="let row" style="font-family: monospace; font-size: 0.82rem; font-weight: 700; color: #111827;">{{ row.referencia }}</td>
          </ng-container>

          <ng-container matColumnDef="monto">
            <th mat-header-cell *matHeaderCellDef>Monto</th>
            <td mat-cell *matCellDef="let row" style="font-weight: 700; color: #1e5a3f;">
              Bs. {{ row.monto | number:'1.2-2' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Estado</th>
            <td mat-cell *matCellDef="let row" style="text-align: center;">
              <span style="display: inline-block; padding: 3px 12px; border-radius: 6px; font-size: 0.72rem; font-weight: 700; color: white;"
                [style.background]="getStatusBg(row.status)">
                {{ getStatusLabel(row.status) }}
              </span>
            </td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let row" style="font-size: 0.78rem; color: #6b7280; white-space: nowrap;">
              {{ row.createdAt | date:'short' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Acciones</th>
            <td mat-cell *matCellDef="let row" style="text-align: center;">
              <div style="display: flex; gap: 4px; justify-content: center; flex-wrap: wrap;">
                <button *ngIf="row.status === 'PENDING'" title="Aprobar" (click)="openApproveModal(row)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">check_circle</mat-icon>
                </button>
                <button *ngIf="row.status === 'PENDING' && esRailN58(row)" title="Emparejar con un movimiento de N58"
                  (click)="openEmparejarN58Modal(row)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">link</mat-icon>
                </button>
                <button *ngIf="row.status === 'PENDING'" title="Rechazar" (click)="openRejectModal(row)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #fecaca; border-radius: 6px; background: #fef2f2; cursor: pointer;">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">cancel</mat-icon>
                </button>
                <span *ngIf="row.status !== 'PENDING'" style="font-size: 0.72rem; color: #9ca3af;">—</span>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden flex flex-col gap-3" *ngIf="referencias.length > 0">
      <div *ngFor="let ref of referencias"
        style="background: white; border-radius: 14px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);"
        [style.borderColor]="expandedCardId === ref.id ? '#1C593D' : '#e5e7eb'">

        <!-- Card header -->
        <div (click)="toggleCard(ref.id)"
          style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; cursor: pointer;"
          [style.background]="expandedCardId === ref.id ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">

          <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; align-items: center; justify-content: center; flex-shrink: 0;"
            [style.background]="ref.status === 'APPROVED' ? '#f0fdf4' : ref.status === 'REJECTED' ? '#fef2f2' : '#fffbeb'">
            <mat-icon style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;"
              [style.color]="ref.status === 'APPROVED' ? '#16a34a' : ref.status === 'REJECTED' ? '#dc2626' : '#f59e0b'">
              {{ ref.status === 'APPROVED' ? 'check_circle' : ref.status === 'REJECTED' ? 'cancel' : 'schedule' }}
            </mat-icon>
          </div>

          <div style="flex: 1; min-width: 0;">
            <div class="flex items-center gap-2 flex-wrap">
              <span *ngIf="!ref.esOperador" class="font-mono font-bold text-xs bg-green-100 text-green-800 px-2 py-0.5 rounded-full">{{ ref.userId }}</span>
              <span *ngIf="ref.esOperador" class="font-bold text-xs px-2 py-0.5 rounded-full" style="background: #eef2ff; color: #4338ca;">Operador</span>
              <span *ngIf="!ref.esOperador" style="font-weight: 700; font-size: 0.85rem; color: #111827;">{{ ref.usuario?.nombre }} {{ ref.usuario?.apellidos }}</span>
            </div>
            <div style="font-size: 0.72rem; margin-top: 1px;"
              [style.color]="ref.esOperador ? '#4338ca' : '#6b7280'">
              {{ ref.esOperador ? (ref.operatorEmail || 'sin operador registrado') : ref.usuario?.email }}
            </div>
            <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 2px;">
              Ref: {{ ref.referencia }} &middot; {{ ref.createdAt | date:'medium' }}
            </div>
            <div class="flex items-center gap-2 flex-wrap" style="margin-top: 4px;">
              <span style="font-weight: 700; font-size: 0.85rem; color: #1e5a3f;">
                Bs. {{ ref.monto | number:'1.2-2' }}
              </span>
              <span
                style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700;"
                [style.background]="getStatusBg(ref.status)">
                {{ getStatusLabel(ref.status) }}
              </span>
            </div>
          </div>

          <mat-icon
            style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease; margin-top: 4px;"
            [style.transform]="expandedCardId === ref.id ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <!-- Card body -->
        <div *ngIf="expandedCardId === ref.id" style="border-top: 1px solid #f3f4f6;">
          <div style="padding: 10px 14px 12px;" class="sm:pl-16">
            <div class="flex flex-wrap gap-3" style="margin-bottom: 2px;">
              <div style="display: flex; align-items: center; gap: 6px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Titular:</span>
                <span style="font-size: 0.85rem; font-weight: 600; color: #374151;">{{ ref.titular }}</span>
              </div>
            </div>
            <div class="flex flex-wrap gap-3" style="margin-top: 4px;">
              <div style="display: flex; align-items: center; gap: 6px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Banco:</span>
                <span style="font-size: 0.85rem; font-weight: 600; color: #374151;">{{ ref.banco }}</span>
              </div>
              <div style="display: flex; align-items: center; gap: 6px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Tipo:</span>
                <span style="font-size: 0.85rem; font-weight: 600; color: #374151;">{{ ref.tipoCuenta }}</span>
              </div>
            </div>
            <div class="flex flex-wrap gap-x-4 gap-y-1" style="margin-top: 4px;">
              <div style="display: flex; align-items: center; gap: 4px;">
                <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Cuenta:</span>
                <span style="font-size: 0.78rem; font-weight: 600; color: #374151; font-family: monospace; word-break: break-all;">{{ ref.cuenta }}</span>
              </div>
            </div>

            <!-- Cuenta de trabajo match (mobile) -->
            <div *ngIf="ref.status === 'PENDING' && ref.cuentaTrabajoMatch"
              style="margin-top: 6px; display: flex; align-items: center; gap: 4px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #16a34a;">link</mat-icon>
              <span style="font-size: 0.75rem; color: #16a34a; font-weight: 600;">
                CT #{{ ref.cuentaTrabajoMatch.cuenta_trabajo_id }} - {{ ref.cuentaTrabajoMatch.nombre }} {{ ref.cuentaTrabajoMatch.apellidos }}
              </span>
            </div>
            <div *ngIf="ref.status === 'PENDING' && !ref.cuentaTrabajoMatch"
              style="margin-top: 6px; display: flex; align-items: center; gap: 4px;">
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #dc2626;">link_off</mat-icon>
              <span style="font-size: 0.75rem; color: #dc2626; font-weight: 600;">Sin cuenta de trabajo asociada</span>
            </div>

            <div *ngIf="ref.status === 'REJECTED' && ref.motivoRechazo"
              style="margin-top: 10px; display: flex; align-items: flex-start; gap: 8px; background: #fef2f2; padding: 10px 12px; border-radius: 10px; border: 1px solid #fecaca;">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626; flex-shrink: 0; margin-top: 1px;">error_outline</mat-icon>
              <span style="font-size: 0.8rem; font-weight: 600; color: #dc2626;">{{ ref.motivoRechazo }}</span>
            </div>

            <!-- Action buttons (mobile) -->
            <div *ngIf="ref.status === 'PENDING'" class="flex gap-3" style="margin-top: 12px; padding-top: 10px; border-top: 1px solid #e5e7eb;">
              <button type="button" (click)="openApproveModal(ref); $event.stopPropagation()"
                style="flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 8px; background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; border-radius: 8px; font-weight: 700; font-size: 0.8rem; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">check_circle</mat-icon>
                Aprobar
              </button>
              <button type="button" (click)="openRejectModal(ref); $event.stopPropagation()"
                style="flex: 1; display: flex; align-items: center; justify-content: center; gap: 6px; padding: 8px; background: #fef2f2; color: #dc2626; border: 1px solid #fecaca; border-radius: 8px; font-weight: 700; font-size: 0.8rem; cursor: pointer;">
                <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">cancel</mat-icon>
                Rechazar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Paginator -->
    <mat-paginator
      *ngIf="total > 0"
      [length]="total"
      [pageSize]="limit"
      [pageSizeOptions]="pageSizeOptions"
      [pageIndex]="page - 1"
      (page)="onPageChange($event)"
      showFirstLastButtons
      aria-label="Seleccionar pagina"
      style="margin-top: 12px;">
    </mat-paginator>

    <!-- Empty state -->
    <div *ngIf="referencias.length === 0"
      style="text-align: center; padding: 48px 20px;">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">description</mat-icon>
      <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No hay referencias para mostrar</p>
    </div>

  </ng-container>
</div>
